import ReservationComponent from "../components/Reservation/ReservationComponent"

const Reservation = () => {
    return (
        <div>
            <ReservationComponent/>
        </div>
    )
}

export default Reservation